module.exports = __webpack_public_path__ + "img/placeholder2.2b86069b.png";